import * as React from "react";

import { Option } from "../../../../types/Option";

export const getDefaultOptionDisplay = <T,>(
	option: Option<T>,
	renderOption?: (option: Option<T>, isSelected: boolean) => React.ReactNode,
	isSelected?: boolean
): React.ReactNode => {
	if (renderOption) {
		return renderOption(option, isSelected ?? false);
	}

	return (
		<div className="flex min-w-0 max-w-[calc(100%-16px)] flex-col">
			<div className="truncate">{option.label}</div>
			{option.subtext && <div className="truncate text-caption text-neutral-5">{option.subtext}</div>}
		</div>
	);
};
